import { Layout, Space } from 'antd';
import styled from 'styled-components';

const Brand = styled.div`
  cursor: pointer;
`;

Brand.Image = styled.img`
  height: 32px;
`;

const Header = styled(Layout.Header)`
  position: sticky;
  top: 0;
  z-index: 1010;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
`;

const Navbar = styled.div`
  display: flex;
`;

const Products = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 320px;
`;

Products.Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

Products.Imagem = styled.img`
  height: 35px;
`;

const User = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 250px;
`;

User.Content = styled(Space)`
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;
User.Email = styled.span``;

export default { Brand, Header, Navbar, Products, User };
